import { render, staticRenderFns } from "./ReleaseNotesSettings.vue?vue&type=template&id=3a0674d6&scoped=true"
import script from "./ReleaseNotesSettings.vue?vue&type=script&lang=js"
export * from "./ReleaseNotesSettings.vue?vue&type=script&lang=js"
import style0 from "./ReleaseNotesSettings.vue?vue&type=style&index=0&id=3a0674d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0674d6",
  null
  
)

export default component.exports